module.exports = __webpack_public_path__ + "assets/media/w2.eac73c53.mp4";